<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column prop="ids" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="orderNum" label="订单号" align="center"></el-table-column>
      <el-table-column prop="phone" label="支付手机号" align="center"></el-table-column>
      <el-table-column prop="productName" label="套餐名" align="center"></el-table-column>
      <el-table-column prop="payTime" label="支付时间" align="center" sortable></el-table-column>
      <el-table-column prop="accountMoney" label="支付金额" align="center"></el-table-column>
      <el-table-column prop="orderStatus" label="订单状态" align="center"></el-table-column>
    </el-table> 
  </div>
</template>
<script>
import { agreementAgreementOrderList } from "@/api/api.js"; //订单列表
export default {
  data() {
    return{
      tableData:[]
    }
  },
  methods: {
    transferOrderStatus(status) {
      let obj = {
        1: "未支付",
        2: "已支付",
        3: "已到账",
        4: "已退款"
      };
      return obj[status];
    },
    // 获取列表的数据
    initData(){
      let params ={
        id:this.$route.query.id
      }
      agreementAgreementOrderList(params).then(res=>{
        if(res.data.code == 200 ){
          this.tableData = res.data.data;
          this.tableData.map((item,index)=>{
            item.ids = index + 1;
            item.orderStatus = this.transferOrderStatus(item.orderStatus);
          })
        }
      })
    },

  },

  mounted() {

  },
  created() {
    
  }
};
</script>

<style scoped lang="less">

</style>


